import React from 'react';
import MenuItem from "../menu-item";
import styles from "./MenuGroup.module.css"
const MenuGroup = ({ group }) => {
    return (
        <div className={styles.menu_group_container}>
            {group.name && <div className={styles.menu_group_caption}>{group.name}</div>}
            <div className={styles.menu_group}>
                {group.items && group.items.map((x, idx) => {
                    return (
                        <MenuItem key={idx} item={x} isFirstOfGroup={idx == 0} isLastOfGroup={idx == group.items.length-1} />
                    );
                })}
            </div>
        </div>
    );
};

export default MenuGroup;